export const RENDER_THD_RECS = 'RENDER_THD_RECS';
export const RENDER_TRANSACTIONAL = 'transactional';
export const RENDER_VISUAL = 'visual';
export const RENDER_CO_WORK = 'work-co';
export const BUNDLE_MINI_TO_PIP_ANALYTICS = 'bundle-mini.viewBundleClick';
